import React from 'react'
import { parse as parseFn, format as formatFn, set as setFn } from 'date-fns'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { DateUtils } from 'react-day-picker'
import TimePicker from './TimePicker'
import './DatePicker.css'

function parseDate(str, format, locale) {
  const parsed = parseFn(str, format, new Date(), { locale })
  return DateUtils.isDate(parsed) ? parsed : undefined
}

function formatDate(date, format, locale) {
  return formatFn(date, format, { locale })
}

export default function DatePicker(props) {
  let {
    date,
    onChange = () => {},
    className,
    timePicker = false,
    disableBefore,
    disableAfter,
    ...rest
  } = props

  if (disableBefore === 'today') {
    disableBefore = new Date()
  }

  let disabledDays

  if (disableBefore || disableAfter) {
    disabledDays = {
      before: disableBefore,
      after: disableAfter
    }
  }

  return (
    <DayPickerInput
      value={date}
      parseDate={parseDate}
      formatDate={formatDate}
      placeholder={timePicker ? 'mm/dd/yyyy, hh:mm' : 'mm/dd/yyyy'}
      format={timePicker ? 'MM/dd/yyyy, hh:mm a' : 'MM/dd/yyyy'}
      dayPickerProps={{
        disabledDays,
      }}
      inputProps={{
        readOnly: true,
        className: className,
        onKeyDown: event => {
          if (event.key === 'Enter') {
            event.target.blur()
          }
        }
      }}
      onDayChange={day => {
        if (!day) {
          onChange(null)
        } else if (date) {
          onChange(setFn(day, {
            hours: date.getHours(),
            minutes: date.getMinutes()
          }))
        } else {
          onChange(day)
        }
      }}
      overlayComponent={timePicker ? (props => (
        <TimeOverlay date={date} {...props} onChange={onChange} />
      )) : undefined}
      {...rest}
    />
  )
}

function TimeOverlay(props) {
  const {
    date,
    onChange,
    children,
    classNames,
    selectedDay,
    month,
    ...rest
  } = props

  return (
    <div {...rest} className={classNames.overlayWrapper}>
      <div className={classNames.overlay}>
        {children}
        <div className="border-t border-gray-300 pt-5 mx-5 mb-5">
          <TimePicker
            date={date}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  )
}
